import React from "react";
import FeatureCard from "../FeatureCard";

export default () => (
  <FeatureCard
    isLocked
    to="/partnership/integrations/my"
    image="/static/img/Card-PartnershipTiers.png"
    imageAlt="Partners shaking hands"
    description="Manage Your Company Integrations"
    loggedOutDescription="Log in to Manage Your Company Integrations"
  >
    View and edit your company's integrations, including the external details viewable by our shared customers.
  </FeatureCard>
);
